"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselRail = exports.CarouselCell = exports.Carousel = exports.CELL_GAP_PADDING_AMOUNT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _useCursor2 = require("use-cursor");
var _ChevronLeftIcon = _interopRequireDefault(require("@artsy/icons/ChevronLeftIcon"));
var _ChevronRightIcon = _interopRequireDefault(require("@artsy/icons/ChevronRightIcon"));
var _useUpdateEffect = require("../../utils/useUpdateEffect");
var _Box = require("../Box");
var _Skip = require("../Skip");
var _VisuallyHidden = require("../VisuallyHidden");
var _CarouselNavigation = require("./CarouselNavigation");
var _paginate = require("./paginate");
var _excluded = ["initialIndex", "children", "Previous", "Next", "Rail", "Cell", "paginateBy", "onChange", "onPageCountChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RAIL_TRANSITION_MS = 500;
var transition = (0, _styledSystem.system)({
  transition: true
});

/** CarouselRailProps */

/** A `CarouselRail` slides back and forth within the viewport */
var CarouselRail = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Carousel__CarouselRail",
  componentId: "sc-k6g4b4-0"
})(["height:100%;margin:0;padding:0;list-style:none;white-space:nowrap;", ""], transition);
exports.CarouselRail = CarouselRail;
CarouselRail.defaultProps = {
  as: "ul",
  display: "flex",
  transition: "transform ".concat(RAIL_TRANSITION_MS, "ms")
};

/** CarouselCellProps */

/** A `CarouselCell` wraps a single child in the carousel */
var CarouselCell = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Carousel__CarouselCell",
  componentId: "sc-k6g4b4-1"
})(["white-space:normal;"]);
exports.CarouselCell = CarouselCell;
CarouselCell.defaultProps = {
  as: "li"
};

/**
 * We share this spacing value with the `Swiper` component
 */
var CELL_GAP_PADDING_AMOUNT = [1, 2];
exports.CELL_GAP_PADDING_AMOUNT = CELL_GAP_PADDING_AMOUNT;
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Carousel__Container",
  componentId: "sc-k6g4b4-2"
})(["position:relative;width:100%;"]);
var Viewport = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Carousel__Viewport",
  componentId: "sc-k6g4b4-3"
})(["width:100%;overflow:hidden;"]);
/**
 * A `Carousel` accepts children or a series of children that are JSX elements.
 * It presents them in a horizontal rail and when the width exceeds the width
 * of the viewport, it presents navigation arrows and allows a user to page
 * through them.
 */
var Carousel = function Carousel(_ref) {
  var _ref$initialIndex = _ref.initialIndex,
    initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
    children = _ref.children,
    _ref$Previous = _ref.Previous,
    Previous = _ref$Previous === void 0 ? _CarouselNavigation.CarouselPrevious : _ref$Previous,
    _ref$Next = _ref.Next,
    Next = _ref$Next === void 0 ? _CarouselNavigation.CarouselNext : _ref$Next,
    _ref$Rail = _ref.Rail,
    Rail = _ref$Rail === void 0 ? CarouselRail : _ref$Rail,
    _ref$Cell = _ref.Cell,
    Cell = _ref$Cell === void 0 ? CarouselCell : _ref$Cell,
    _ref$paginateBy = _ref.paginateBy,
    paginateBy = _ref$paginateBy === void 0 ? "page" : _ref$paginateBy,
    onChange = _ref.onChange,
    onPageCountChange = _ref.onPageCountChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerRef = (0, _react.useRef)(null);
  var viewportRef = (0, _react.useRef)(null);
  var startRef = (0, _react.useRef)(null);
  var endRef = (0, _react.useRef)(null);
  var cells = (0, _react.useMemo)(function () {
    return _react.Children.toArray(children).filter(_react.isValidElement).map(function (child) {
      return {
        child: child,
        ref: /*#__PURE__*/(0, _react.createRef)()
      };
    });
  }, [children]);
  var _useState = (0, _react.useState)([0]),
    _useState2 = _slicedToArray(_useState, 2),
    pages = _useState2[0],
    setPages = _useState2[1];
  var _useCursor = (0, _useCursor2.useCursor)({
      initialCursor: initialIndex,
      max: pages.length
    }),
    index = _useCursor.index,
    handleNext = _useCursor.handleNext,
    handlePrev = _useCursor.handlePrev,
    setCursor = _useCursor.setCursor;
  var init = function init() {
    var viewport = viewportRef.current;
    var values = cells.map(function (_ref2) {
      var ref = _ref2.ref;
      return ref.current.clientWidth;
    });
    setPages((0, _paginate.paginateCarousel)({
      viewport: viewport.clientWidth,
      values: values,
      paginateBy: paginateBy
    }));
  };
  (0, _react.useEffect)(function () {
    init();
    window.addEventListener("resize", init);
    return function () {
      window.removeEventListener("resize", init);
    };
  }, [cells]);
  var skipToEnd = function skipToEnd() {
    if (!endRef.current) return;
    endRef.current.focus();
    setCursor(pages.length - 1);
  };
  var skipToStart = function skipToStart() {
    if (!startRef.current) return;
    startRef.current.focus();
    setCursor(0);
  };
  var handleKeydown = function handleKeydown(_ref3) {
    var key = _ref3.key;
    if (!containerRef.current) return;

    // Only triggers keyboard navigation if component is in focus
    if (!containerRef.current.contains(document.activeElement)) {
      return;
    }
    switch (key) {
      case "ArrowRight":
        handleNext();
        break;
      case "ArrowLeft":
        handlePrev();
        break;
      default:
        break;
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener("keydown", handleKeydown);
    return function () {
      return document.removeEventListener("keydown", handleKeydown);
    };
  }, [handleKeydown]);
  (0, _useUpdateEffect.useUpdateEffect)(function () {
    onChange && onChange(index);
  }, [onChange, index]);
  (0, _useUpdateEffect.useUpdateEffect)(function () {
    onPageCountChange && onPageCountChange(pages.length);
  }, [onPageCountChange, pages.length]);
  var offset = "-".concat(pages[index], "px");
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: containerRef
  }, rest), /*#__PURE__*/_react.default.createElement(_Skip.Skip, {
    ref: startRef,
    onClick: skipToEnd,
    width: "100%",
    mb: 1
  }, "Skip to end of content"), /*#__PURE__*/_react.default.createElement("nav", null, /*#__PURE__*/_react.default.createElement(Previous, {
    onClick: handlePrev,
    disabled: index === 0,
    "aria-label": "Previous page"
  }, /*#__PURE__*/_react.default.createElement(_ChevronLeftIcon.default, {
    width: 15,
    height: 15
  })), /*#__PURE__*/_react.default.createElement(Next, {
    onClick: handleNext,
    disabled: index === pages.length - 1,
    "aria-label": "Next page"
  }, /*#__PURE__*/_react.default.createElement(_ChevronRightIcon.default, {
    width: 15,
    height: 15
  }))), /*#__PURE__*/_react.default.createElement(Viewport, {
    ref: viewportRef
  }, /*#__PURE__*/_react.default.createElement(Rail, {
    style: {
      transform: "translateX(".concat(offset, ")")
    }
  }, cells.map(function (_ref4, i) {
    var child = _ref4.child,
      ref = _ref4.ref;
    var isLast = i === cells.length - 1;
    return /*#__PURE__*/_react.default.createElement(Cell, {
      key: i,
      ref: ref,
      pr: !isLast && CELL_GAP_PADDING_AMOUNT
    }, child);
  }))), /*#__PURE__*/_react.default.createElement(_Skip.Skip, {
    ref: endRef,
    onClick: skipToStart,
    width: "100%",
    mt: 1
  }, "Skip to beginning of content"), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, {
    "aria-live": "polite",
    "aria-atomic": "true"
  }, "Page ", index + 1, " of ", pages.length));
};
exports.Carousel = Carousel;
Carousel.displayName = "Carousel";
//# sourceMappingURL=Carousel.js.map